/**
 * Topographic contour pattern — an absolutely-positioned SVG texture layer.
 * Place inside a `relative` container; it fills 100% width/height.
 */
export function TopoPatternBg({
  className = '',
  opacity = 0.07,
}: {
  className?: string;
  opacity?: number;
}) {
  return (
    <div
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      aria-hidden="true"
    >
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <pattern
            id="pp-topo"
            x="0"
            y="0"
            width="240"
            height="180"
            patternUnits="userSpaceOnUse"
          >
            <path d="M-20,18 Q40,6 90,20 Q140,34 190,20 Q215,12 240,16" fill="none" stroke="#5A7D5E" strokeWidth="0.6" />
            <path d="M-20,48 Q35,36 85,50 Q135,64 185,50 Q210,44 240,46" fill="none" stroke="#5A7D5E" strokeWidth="0.8" />
            <path d="M-20,78 Q40,68 90,80 Q140,92 190,80 Q213,74 240,76" fill="none" stroke="#5A7D5E" strokeWidth="0.8" />
            <path d="M-20,108 Q42,98 92,110 Q142,122 192,110 Q214,104 240,107" fill="none" stroke="#5A7D5E" strokeWidth="0.7" />
            <path d="M-20,138 Q45,128 95,140 Q145,152 195,140 Q215,134 240,137" fill="none" stroke="#5A7D5E" strokeWidth="0.6" />
            <path d="M-20,168 Q48,158 98,170 Q148,182 198,170 Q217,164 240,167" fill="none" stroke="#5A7D5E" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#pp-topo)" opacity={opacity} />
      </svg>
    </div>
  );
}
